var map = {
	"./1.webp": 4269,
	"./2.jpeg": 6395,
	"./4.jpeg": 4897,
	"./41.webp": 3437,
	"./5.jpeg": 1946,
	"./51.webp": 4868,
	"./6.webp": 1724,
	"./afcon25.webp": 5686,
	"./championsleague02.jpg": 4901,
	"./eredivisieposter.jpeg": 7993,
	"./euro24.jpg": 6979,
	"./f1poster.jpg": 4398,
	"./f1poster2.jpeg": 8435,
	"./laliga.webp": 3798,
	"./ligue1d.jpg": 5705,
	"./motogp.jpg": 368,
	"./nascarsports.jpg": 9363,
	"./peremierleague.jpg": 3200,
	"./seriaitaly.webp": 7905,
	"./tennis.jpg": 2031,
	"./ufc.jpg": 5160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6994;